<template>
  <div class="content home-page" style='padding-top: 20px'>
    <!--      <Header></Header>-->
    <div class="" @click="back"
         style="width: 100px;height:100px;text-align: center;display: flex;align-items: center;justify-content: center;margin-top: 20px">
      <img width="50" src="../../static/images/back.png"/>
    </div>
    <div class="information2">
      <div class="faq-content" v-if="list!=''">
        <div class="" style="color: white">
          <p class="fs50 ac"><span>{{ $t('TC') }}</span></p>
          <p class="mt30" v-html="list"></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>


export default {
  components: {

  },
  data() {
    return {
      list: ''

    }
  },
  watch: {},
  computed: {},
  mounted() {
  },
  created() {
    this.getHome()
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    getHome() {
      let that = this;
      that.$parent.loadModal(true);
      let data = {
        type: '2'
      }
      that.$api.post('/api/index/help', data, r => {
        that.$parent.returnCode(r, function () {
          that.$parent.loadModal(false);
          that.list = r.data.content
        });

      })
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/termsAndCondition.vue